import React, { Component } from 'react';
import { LandingNav } from 'components/nav/LandingNav';
import { t } from "i18next";
import Checkbox from 'components/Checkbox';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';

import { userActions } from 'redux/_actions';
import { connect } from 'react-redux';
import { Input, Button, Row, Col, Modal, ModalBody, Spinner } from 'reactstrap';
import { LoadScript, Autocomplete } from '@react-google-maps/api';
import { generateId, invokeHttpsApi, listenDb } from 'utils/API';
import { AiFillPlusCircle, AiFillMinusCircle } from 'react-icons/ai';
import { MdDelete, MdEdit, MdClose, MdSwitchCamera, MdError, MdUpload } from 'react-icons/md';
import { FaCamera } from 'react-icons/fa';
import { Camera } from "react-camera-pro";
import { uploadImage } from 'utils/File';

import { 
    STRIPE_PUBLISHABLE_KEY, HOUR_TIME, getHour, getDayStart, getMinutes, MIN_TIME, toSimpleDate, toSimpleTime, validateEmail
} from 'utils/Utils';

import { loadStripe } from '@stripe/stripe-js';
import { getDistance } from 'geolib';

class BookPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            id: '',
            activeTab: 0,
            cameraCount: 0,
            delivery: {
                id: generateId("delivery")
            },
            dropoff: {},
            items: {},
            stores: {},
            createItem: {
                helperCount: 1
            },
        };
        this.camera = React.createRef();
        this.autocomplete = null
        this.autocomplete1 = null
        this.onLoadMap = this.onLoadMap.bind(this);
        this.onPlaceChanged = this.onPlaceChanged.bind(this);
        this.onLoadMap1 = this.onLoadMap1.bind(this);
        this.onPlaceChanged1 = this.onPlaceChanged1.bind(this);
    }

    componentDidMount() {
        const { delivery } = this.state;
        
        const deliveryId = this.props.match && this.props.match.params ? this.props.match.params.deliveryId : null;
        
        if (deliveryId) {
            listenDb("/delivery/" + deliveryId, ((data)=> {
                
                if (data) {
                    for (const [k, v] of Object.entries(data)) {
                        delivery[k] = v;
                    }
                }
    
                this.setState({delivery: delivery});
            }))
        }
        listenDb("store", ((data)=> {
            const stores = {};
            let storeChoice = null;
            const storeId = this.props.match && this.props.match.params ? this.props.match.params.storeId : null;
            if (data) {
                for (const [k, v] of Object.entries(data)) {
                    stores[k] = v;
                }
                if (storeId && stores[storeId]) {
                    storeChoice = {};
                    for (const [k, v] of Object.entries(stores[storeId])) {
                        storeChoice[k] = v;
                    }
                    if (!delivery.location) {
                        delivery.location = {};
                    }
                    delivery.location.store = storeChoice;
                }
            }

            this.setState({stores: stores, storeChoice: storeChoice, delivery: delivery});
        }))
        listenDb("items", ((data)=> {
            const items = {};
            if (data) {
                for (const [k, v] of Object.entries(data)) {
                    items[k] = v;
                }
            }

            this.setState({items: items});
        }))
    }

    onLoadMap (autocomplete) {
        this.autocomplete = autocomplete
    }

    onPlaceChanged() {
        const {delivery} = this.state;
        
        if (!delivery.location) {
            delivery.location = {};
        }
        
        if (this.autocomplete !== null) {
            const place = this.autocomplete.getPlace();
            this.setState({storeInput: place.formatted_address});
            
            delivery.location.store = place;
            delivery.location.store.lat = place.geometry.location.lat();
            delivery.location.store.lng = place.geometry.location.lng();

            this.setState({delivery: delivery});
        }
    }

    onLoadMap1(autocomplete) {
        this.autocomplete1 = autocomplete
    }

    onPlaceChanged1() {
        const {delivery} = this.state;
        
        if (!delivery.location) {
            delivery.location = {};
        }
        
        if (this.autocomplete1 !== null) {
            const place = this.autocomplete1.getPlace();
            this.setState({dropInput: place.formatted_address});

            this.onPlaceUpdated(place);
            
            delivery.location.dropoff = place;
            
            delivery.location.dropoff.lat = place.geometry.location.lat();
            delivery.location.dropoff.lng = place.geometry.location.lng();

            this.setState({delivery: delivery});
        }
    }

    getLocation(place) {
        const lat = place.geometry.location.lat();
        const lng = place.geometry.location.lng();

        return {
            latitude: lat,
            longitude: lng,
        }
    }

    onPlaceUpdated(place) {
        const { delivery } = this.state;

        if (delivery.location && delivery.location.store && delivery.location.store.lat && delivery.location.store.lat > 0) {
            const distance = getDistance(
                {
                    latitude: delivery.location.store.lat,
                    longitude: delivery.location.store.lng,
                },
                this.getLocation(place)
            );

            this.setState({distance: distance})
        }
    }

    getDistanceDiff(from, to) {
        if (from.lat && from.lng && to.lat && to.lng) {
            return getDistance({
                latitude: from.lat,
                longitude: from.lng,
            },{
                latitude: to.lat,
                longitude: to.lng,
            },);
        }
        return 0;
    }

    getTotalDistance() {
        const { delivery } = this.state;
        const store = this.getStoreLocation();
        const dropoff = this.getDropoffLocation();

        let result = 0;
        if (delivery.location && store && dropoff) {
            /*let items = [];
            items.push(delivery.location.store);
            for (const item of Object.values(delivery.location.dropoffLocations)) {
                items.push(item);
            }
            if (items.length > 1) {
                for (let i = 0; i < items.length - 1; i ++) {
                    result += this.getDistanceDiff(items[i], items[i + 1]);
                }
            }*/
            result += this.getDistanceDiff(store, dropoff);
        }
        return parseInt(result / 1609.344);
    }

    getTotalPrice() {
        const { delivery } = this.state;

        let result = 0;
        if (delivery.items) {
            result = 110;
            let itemCount = 0;
            for (const item of Object.values(delivery.items)) {
                itemCount += item.count;
            }

            if (itemCount === 2) {
                result = 130;
            } else if (itemCount === 3) {
                result = 160;
            }
            const distance = this.getTotalDistance();
            if (distance > 20) {
                result += 2.5 * (distance - 20);
            }
            if (itemCount > 3) {
                result += 40 * (itemCount - 3);
            }
            for (const item of Object.values(delivery.items)) {
                if (item.assemblyFull) {
                    result += 25;
                }
            }
        }

        return result;
    }

    renderCustomerInfo() {
        const {delivery} = this.state;
        if (!delivery.customer) {
            delivery.customer = {};
        }

        return (
            <div>
                <div className='book-item-subtitle'>
                    <div className='book-item-index'>1</div>
                    <h3 className='book-item-header'>{t('customer_information')}</h3>
                </div>
                <div className='input-item'>
                    <h4 className='input-label'>{t('firstname')}</h4>
                    <Input type="text" className='form-control' placeholder={t('firstname_placeholder')} name="firstname" id="firstname" onChange={e => {
                        delivery.customer.firstName = e.target.value;
                        this.setState({delivery: delivery});
                    }} value={delivery.customer.firstName ? delivery.customer.firstName : ""} />
                </div>
                <div className='input-item'>
                    <h4 className='input-label'>{t('lastname')}</h4>
                    <Input type="text" className='form-control' placeholder={t('lastname_placeholder')} name="lastname" id="lastname" onChange={e => {
                        delivery.customer.lastname = e.target.value;
                        this.setState({delivery: delivery});
                    }} value={delivery.customer.lastname ? delivery.customer.lastname : ""} />
                </div>
                <div className='input-item'>
                    <h4 className='input-label'>{t('phone')}</h4>
                    <Input type="text" className='form-control' placeholder={t('phone_placeholder')} name="phone" id="phone" onChange={e => {
                        delivery.customer.phone = e.target.value;
                        this.setState({delivery: delivery});
                    }} value={delivery.customer.phone ? delivery.customer.phone : ""} />
                </div>
                <div className='input-item'>
                    <h4 className='input-label'>{t('email')}</h4>
                    <Input type="email" className='form-control' placeholder={t('email_placeholder')} name="email" id="email" onChange={e => {
                        delivery.customer.email = e.target.value;
                        this.setState({delivery: delivery});
                    }} value={delivery.customer.email ? delivery.customer.email : ""} />
                </div>
                <div className='book_note'>
                    {t('customer_note')}
                </div>
            </div>
        )
    }

    renderLocationInfo() {
        const {delivery, storeChoice} = this.state;
        if (!delivery.location) {
            delivery.location = {};
        }
        if (!delivery.location.store) {
            delivery.location.store = {};
        }
        if (!delivery.location.dropoff) {
            delivery.location.dropoff = {};
        }

        const store = delivery.location.store;
        const dropoff = delivery.location.dropoff;
        const distance = this.getTotalDistance();

        const storeLocation = store.formatted_address ? store.formatted_address : "Input place name for store location";
        const dropLocation = dropoff.formatted_address ? dropoff.formatted_address : "Input place name for drop off location";

        return (
            <div>
                <div className='book-item-subtitle'>
                    <div className='book-item-index'>2</div>
                    <h3 className='book-item-header'>{t('locations')}</h3>
                </div>
                
                <div className='input-item'>
                    <h4 className='input-label'>{t('your_store')}</h4>
                    <div className='form-setting-input'>
                        <div className='book-item-view wrap-content-parent' style={{margin: '5px 7px'}}>
                            {delivery.location.store && delivery.location.store.name ? delivery.location.store.name : t('pick_store_prompt')}
                        </div>
                        
                        {!storeChoice && (
                        <div className='wrap-content-parent'>
                            <div className='wrap-content-fill-child' />
                            <Button className='btn-normal' onClick={e=> {
                                this.setState({storeList: true});
                            }}>{t('pick_store')}</Button>
                        </div>
                        )}
                        <LoadScript
                            googleMapsApiKey={process.env.REACT_APP_GOOGLE_API_KEY}
                            libraries={["places"]} >
                            <Autocomplete
                                onLoad={this.onLoadMap}
                                onPlaceChanged={this.onPlaceChanged} >
                                <input
                                    type="text"
                                    placeholder={storeLocation}
                                    className="form-control"
                                    onChange={e=> {
                                        this.setState({storeInput: e.target.value});
                                    }} />
                            </Autocomplete>
                        </LoadScript>
                        <div className='book-info-layout'>
                            <h4 className='input-label'>{t('unit_number')}</h4>
                            <Input type="text" className='form-control' name="email" id="email" onChange={e => {
                                delivery.location.store.unitNumber = e.target.value;
                                this.setState({delivery: delivery});
                            }} value={delivery.location.store.unitNumber} />
                            <div style={{height: 15}} />
                            <Checkbox 
                                label={t('need_stairs')}
                                isChecked={delivery.location.store.needStairs}
                                onToggle={(update)=> {
                                    delivery.location.store.needStairs = update;
                                    this.setState({delivery: delivery});
                                }} />
                            <div style={{height: 15}} />
                            <Checkbox 
                                label={t('hardwood_floors')}
                                isChecked={delivery.location.store.hardwood}
                                onToggle={(update)=> {
                                    delivery.location.store.hardwood = update;
                                    this.setState({delivery: delivery});
                                }} />
                            <div style={{height: 15}} />
                            <h4 className='input-label'>{t('parking_info')}</h4>
                            <Input type="textarea" className='form-control' name="parking" id="parking" onChange={e => {
                                delivery.location.store.parkingInfo = e.target.value;
                                this.setState({delivery: delivery});
                            }} value={delivery.location.store.parkingInfo} />
                            <div style={{height: 15}} />
                        </div>
                    </div>
                </div>
                
                <div className='input-item'>
                    <h4 className='input-label'>{t('drop_off_address')}</h4>
                    <div className='form-setting-input'>
                        <LoadScript
                            googleMapsApiKey={process.env.REACT_APP_GOOGLE_API_KEY}
                            libraries={["places"]} >
                            <Autocomplete
                                onLoad={this.onLoadMap1}
                                onPlaceChanged={this.onPlaceChanged1} >
                                <input
                                    type="text"
                                    placeholder={dropLocation}
                                    className="form-control" 
                                    onChange={e=> {
                                        this.setState({dropInput: e.target.value});
                                    }} />
                            </Autocomplete>
                        </LoadScript>
                        
                        <div className='book-info-layout'>
                            <div className='info-label'>Distance: {distance} {distance > 1 ? "miles" : "mile"}</div>
                            <div style={{height: 15}} />
                            <h4 className='input-label'>{t('unit_number')}</h4>
                            <Input type="text" className='form-control' name="email" id="email" onChange={e => {
                                delivery.location.dropoff.unitNumber = e.target.value;
                                this.setState({delivery: delivery});
                            }} value={delivery.location.dropoff.unitNumber} />
                            <div style={{height: 15}} />
                            <Checkbox 
                                label={t('need_stairs')}
                                isChecked={delivery.location.dropoff.needStairs}
                                onToggle={(update)=> {
                                    delivery.location.dropoff.needStairs = update;
                                    this.setState({delivery: delivery});
                                }} />
                            <div style={{height: 15}} />
                            <Checkbox 
                                label={t('hardwood_floors')}
                                isChecked={delivery.location.dropoff.hardwood}
                                onToggle={(update)=> {
                                    delivery.location.dropoff.hardwood = update;
                                    this.setState({delivery: delivery});
                                }} />
                            <div style={{height: 15}} />
                            <h4 className='input-label'>{t('parking_info')}</h4>
                            <Input type="textarea" className='form-control' name="parking" id="parking" onChange={e => {
                                delivery.location.dropoff.parkingInfo = e.target.value;
                                this.setState({delivery: delivery});
                            }} value={delivery.location.dropoff.parkingInfo} />
                            <div style={{height: 15}} />
                        </div>
                    </div>
                </div>
                
            </div>
        )
    }

    renderItems() {
        const {delivery} = this.state;
        if (!delivery.items) {
            delivery.items = {};
        }

        let viewArr = [];
        for (const item of Object.values(delivery.items)) {
            viewArr.push(
                <div className='book-item-view wrap-content-parent' style={{margin: '5px 7px'}}>
                    {item.title} {"(Qty = " + item.count + ")"}
                    {item.photoUri && (<img src={item.photoUri} alt='receipt' style={{height: 30, margin: '0px 10px'}} />)}
                    <div className='wrap-content-fill-child' />
                    <MdEdit onClick={e=> {
                        this.setState({addItem: item, isAdding: true});
                    }}/>
                    <MdDelete onClick={e=> {
                        delete delivery.items[item.id];
                        this.setState({delivery: delivery});
                    }}/>
                </div>
            )
        }
        return (
            <div>
                <div className='book-item-subtitle'>
                    <div className='book-item-index'>3</div>
                    <h3 className='book-item-header'>{t('items')}</h3>
                </div>
                {viewArr}
                <div className='input-item text-center'>
                    <Button className='btn-book' onClick={e=> {
                        this.setState({isAdding: true});
                    }}>{t('add_item')}</Button>
                </div>
            </div>
        )
    }

    uploadItemPhotos(addFiles) {

        this.setState({progress: true});
        this.uploadItemPhoto(addFiles[0], () =>  {
            addFiles.shift();

            if (addFiles.length > 0) {
                this.uploadItemPhotos(addFiles)
            } else {
                
                this.setState({progress: false, addFiles: null});
            }
        }, (error) => {
            alert("Saving Image File Failed.\n" + error);
            this.setState({
                progress: false
            });
        })
    }

    uploadItemPhoto(file, success, failure) {
        const {delivery, addItem} = this.state;

        const path = "/delivery/" + delivery.id + "/items/" + addItem.id + "/photos";

        const photoItem = {
            id: generateId(path),
        }

        uploadImage(photoItem.id, path, file, (url) => {
            if (!addItem.photos) {
                addItem.photos = {};
            }
            photoItem.photoUri = url;
            addItem.photos[photoItem.id] = photoItem;
            
            this.setState({addItem: addItem});
            success();
        }, (state, progress) => {
            if (state === 'running') {
                this.setState({imageProgress: progress});
            } else {
                this.setState({imageProgress: 0});
            }
        }, error => {
            failure(error);
        });
    }

    uploadReceiptPhoto(file) {
        const {delivery, addItem} = this.state;

        this.setState({progress: true});
        uploadImage(addItem.id, "/delivery/" + delivery.id + "/items/", file, (url) => {
            addItem.photoUri = url;
            
            this.setState({addItem: addItem, addFile: null, progress: false});
        }, (state, progress) => {
            if (state === 'running') {
                this.setState({imageProgress: progress});
            } else {
                this.setState({imageProgress: 0});
            }
        }, error => {
            alert("Saving Image File Failed.\n" + error);
            this.setState({
                progress: false
            });
        });
    }

    renderItemPhoto() {
        const {addFiles, cameraCount, progress} = this.state;
        return (
            <div className='auth-container'>
                <div className='auth-layout'>
                    <h2 className='info-label-l text-center'>{t('take_item_photo')}</h2>
                    <div className='camera-view'>
                        <Camera ref={this.camera}
                            facingMode="environment" 
                            numberOfCamerasCallback={v=> {
                                if (v === 1) {
                                    try {
                                        this.camera.current.switchCamera();
                                    }
                                    catch(err) {
                                        console.log("switch camera failed", err)
                                    }
                                }
                                this.setState({cameraCount: v});
                            }} />
                    </div>
                    <Input type="file" name="file" id="imageFile" accept=".png,.jpg,.jpeg" multiple={true} onChange={e => {       
                        let update = [];

                        for (const file of e.target.files) {
                            update.push(file);
                        }
                        this.setState({addFiles: update});
                    }} />
                    <div style={{height: 15}} />
                    {progress ? (
                    <div className='text-center'>
                        <Spinner size='nm' color='primary' />
                    </div>
                    ) : (
                    <div className='text-center'>
                        <Button className='btn-normal' style={{margin: 5}} onClick={e=> {
                            const photo = this.camera.current.takePhoto();

                            fetch(photo)
                            .then(res => res.blob())
                            .then(blob => {
                                const file = new File([blob], "File name",{ type: "image/jpeg" })
                                this.setState({progress: true});
                                this.uploadItemPhoto(file, () =>  {
                                    this.setState({progress: false, addItemPhoto: false});
                                }, (error) => {
                                    alert("Saving Image File Failed.\n" + error);
                                    this.setState({
                                        progress: false
                                    });
                                })
                            })
                        }}><FaCamera /></Button>
                        {addFiles && Object.values(addFiles).length > 0 && (
                        <Button className='btn-normal' style={{margin: 5}} onClick={e=> {
                            this.uploadItemPhotos(addFiles);
                        }}><MdUpload /></Button>
                        )}
                        {cameraCount > 1 && (
                        <Button className='btn-normal' style={{margin: 5}} onClick={e=> {
                            try {
                                this.camera.current.switchCamera();
                            }
                            catch(err) {
                                console.log("switch camera failed", err)
                            }
                        }}><MdSwitchCamera /></Button>
                        )}
                        <Button className='btn-outline' style={{margin: 5}} onClick={e=> {
                            this.setState({addItemPhoto: false})
                        }}><MdClose /></Button>
                        
                    </div>
                    )}
                </div>
            </div>
        )
    }

    renderReceiptPhoto() {
        const {addFile, cameraCount, progress} = this.state;
        return (
            <div className='auth-container' onClick={e=>{}}>
                <div className='auth-layout'>
                    <h2 className='info-label-l text-center'>{t('take_receipt_photo')}</h2>
                    <div className='camera-view'>
                        <Camera ref={this.camera} 
                            facingMode="environment" 
                            numberOfCamerasCallback={v=> {
                                if (v === 1) {
                                    try {
                                        this.camera.current.switchCamera();
                                    }
                                    catch(err) {
                                        console.log("switch camera failed", err)
                                    }
                                }
                                this.setState({cameraCount: v});
                            }} />
                    </div>
                    <Input type="file" name="file" id="imageFile" accept=".png,.jpg,.jpeg" multiple={false} onChange={e => {
                        if (e.target.files && e.target.files.length > 0) {
                            this.setState({addFile: e.target.files[0]})
                        }
                    }} />
                    <div style={{height: 15}} />
                    {progress ? (
                    <div className='text-center'>
                        <Spinner size='nm' color='primary' />
                    </div>
                    ) : (
                    <div className='text-center'>
                        <Button className='btn-normal' style={{margin: 5}} onClick={e=> {
                            const photo = this.camera.current.takePhoto();

                            fetch(photo)
                            .then(res => res.blob())
                            .then(blob => {
                                const file = new File([blob], "File name",{ type: "image/jpeg" })

                                this.uploadReceiptPhoto(file);
                            })
                        }}><FaCamera /></Button>
                        {addFile && (
                        <Button className='btn-normal' style={{margin: 5}} onClick={e=> {
                            this.uploadReceiptPhoto(addFile);
                        }}><MdUpload /></Button>
                        )}
                        {cameraCount > 1 && (
                        <Button className='btn-normal' style={{margin: 5}} onClick={e=> {
                            try {
                                this.camera.current.switchCamera();
                            }
                            catch(err) {
                                console.log("switch camera failed", err)
                            }
                        }}><MdSwitchCamera /></Button>
                        )}
                        <Button className='btn-outline' style={{margin: 5}} onClick={e=> {
                            this.setState({addPhoto: false})
                        }}><MdClose /></Button>
                    </div>
                    )}
                </div>
            </div>
        )
    }

    renderAddItem() {
        const {delivery, items, addItem, progress, addPhoto, addItemPhoto, isAdding} = this.state;
        let viewArr = [];
        if (!isAdding) {
            return <div/>;
        }
        
        for (const item of Object.values(items)) {
            viewArr.push(
                <div className='book-item-view' onClick={e=> {
                    const toAdd = {
                        id: generateId("/delivery/" + delivery.id + "/items"),
                        title: item.title,
                        helperCount: item.helperCount,
                        count: 0,
                        assemblyFull: false,
                        breakdownRequired: false,
                    }
                    this.setState({addItem: toAdd});
                }}>
                    {item.title}
                </div>
            )
        }
        if (addItem) {
            return (
                <div className='book-add'>
                    <div className='container'>
                        <h1 className='book-title'>{t('add_an_item')}</h1>
                        <div className='book-container'>
                            <Input type="text" className='form-control book-item-view' name="item_title" id="item_title" onChange={e => {
                                addItem.title = e.target.value;
                                this.setState({addItem: addItem});
                            }} value={addItem.title} />
                            <div style={{height: 10}} />
                            <div className='wrap-content-parent'>
                                <div className='wrap-content-fill-child info-label-l'>{t('how_many')}</div>
                                <div className='wrap-content-wrap-child info-label-l'>
                                    <span style={{color: '#666'}} onClick={e=> {
                                        if (addItem.count > 1) {
                                            addItem.count -= 1;
                                            this.setState({addItem: addItem});
                                        }
                                    }}><AiFillMinusCircle /></span>
                                    <div className='info-label-l text-center' style={{display: 'inline-block', width: 80}}>{addItem.count}</div>
                                    <span style={{color: '#3063FF'}} onClick={e=> {
                                            addItem.count += 1;
                                            this.setState({addItem: addItem});
                                    }}><AiFillPlusCircle /></span>
                                </div>
                            </div>
                            <div style={{height: 15}} />
                            {addItem.count > 0 && (
                            <div>
                                <Checkbox 
                                    label={t('full_assembly_title')}
                                    isChecked={addItem.assemblyFull}
                                    onToggle={(update)=> {
                                        addItem.assemblyFull = update;
                                        this.setState({addItem: addItem});
                                    }} />
                                <div className='info-label-l text-center'>
                                    {t('full_assembly_text')}
                                </div>
                                <div style={{height: 15}} />
                                <Checkbox 
                                    label={t('breakdown_title')}
                                    isChecked={addItem.breakdownRequired}
                                    onToggle={(update)=> {
                                        addItem.breakdownRequired = update;
                                        this.setState({addItem: addItem});
                                    }} />
                                <div className='info-label-l text-center'>
                                    {t('breakdown_text')}
                                </div>
                                
                                <div style={{height: 25}} />
                                <div className='divider' />
                                <div style={{height: 10}} />
                                <div className='info-label-l text-center'>
                                    {t('add_item_photo_prompt')}
                                </div>

                                {addItem.photos && (
                                <Row className='text-center' style={{marginTop: 10, marginBottom: 0, marginLeft: 0, marginRight: 0}}>
                                    {Object.values(addItem.photos).map((item,idx) => (
                                        <Col key={idx} xs={3}>
                                            <img src={item.photoUri} alt="RECEIPT" style={{width: '100%'}} />
                                            <div className='text-center' style={{margin: '10px 0px'}}>
                                                <Button className='btn-cancel' onClick={e=>{
                                                    delete addItem.photos[item.id];
                                                    this.setState({addItem: addItem})
                                                }}><MdDelete /></Button>
                                            </div>
                                        </Col>
                                    ))}
                                </Row>
                                )}
                                <div style={{height: 15}} />
                                <div className='text-center'>
                                    <Button className='btn-outline' style={{width: 240}} onClick={e=> {
                                        this.setState({addItemPhoto: true});
                                    }}>{t('add_item_photo')}</Button>
                                </div>

                                <div style={{height: 15}} />
                                <div className='info-label-l text-center'>
                                    {t('add_photo_prompt')}
                                </div>

                                {addItem.photoUri && (
                                <div className='text-center'>
                                    <img src={addItem.photoUri} alt="RECEIPT" style={{width: '50%'}} />
                                </div>
                                )}
                                <div className='text-center'>
                                    <Button className='btn-outline' style={{width: 240}} onClick={e=> {
                                        this.setState({addPhoto: true});
                                    }}>{t('add_photo')}</Button>
                                </div>
                                <div className='text-center'>
                                    <Button className='btn-outline' style={{width: 240}} onClick={e=> {
                                        addItem.details = {};
                                        this.setState({addItem: addItem});
                                    }}>{t('add_optional_details')}</Button>
                                </div>
                                <div style={{height: 15}} />
                                {addItem.details && (
                                    <Row>
                                        <Col xs={4}>
                                            <Input 
                                                type="number" 
                                                step={0.01}
                                                className='form-control' 
                                                placeholder={t('width_placeholder')} 
                                                name="width" id="width" 
                                                onChange={e => {
                                                    addItem.details.width = parseFloat(e.target.value);
                                                    this.setState({addItem: addItem});
                                                }} value={addItem.details.width} />
                                        </Col>
                                        <Col xs={4}>
                                            <Input 
                                                type="number" 
                                                step={0.01}
                                                className='form-control' 
                                                placeholder={t('height_placeholder')} 
                                                name="height" id="height" 
                                                onChange={e => {
                                                    addItem.details.height = parseFloat(e.target.value);
                                                    this.setState({addItem: addItem});
                                                }} value={addItem.details.height} />
                                        </Col>
                                        <Col xs={4}>
                                            <Input 
                                                type="number" 
                                                step={0.01}
                                                className='form-control' 
                                                placeholder={t('depth_placeholder')} 
                                                name="depth" id="depth" 
                                                onChange={e => {
                                                    addItem.details.depth = parseFloat(e.target.value);
                                                    this.setState({addItem: addItem});
                                                }} value={addItem.details.depth} />
                                        </Col>
                                        <Col xs={12} style={{marginTop: 10, marginBottom: 15}}>
                                            <Input 
                                                type="number" 
                                                step={0.01}
                                                className='form-control' 
                                                placeholder={t('weight_placeholder')} 
                                                name="weight" id="weight" 
                                                onChange={e => {
                                                    addItem.details.weight = parseFloat(e.target.value);
                                                    this.setState({addItem: addItem});
                                                }} value={addItem.details.weight} />
                                        </Col>
                                        <Col xs={12}>
                                            <Input 
                                                type="textarea" 
                                                className='form-control' 
                                                placeholder={t('other_placeholder')} 
                                                name="other" id="other" 
                                                onChange={e => {
                                                    addItem.details.other = e.target.value;
                                                    this.setState({addItem: addItem});
                                                }} value={addItem.details.other} />
                                        </Col>
                                    </Row>
                                )}
                                <div style={{height: 15}} />
                            </div>
                            )}
                            <div className='wrap-content-parent'>
                                <div className='wrap-content-fill-child' />
                                {progress ? (
                                <Spinner size="nm" color="primary" />
                                ) : (
                                <div className='wrap-content-wrap-child'>
                                    {addItem.count > 0 && (
                                    <Button className='btn-normal' style={{marginRight: 10}} onClick={e=> {
                                        if (!delivery.items) {
                                            delivery.items = {};
                                        }
                                        if(!addItem.photos || Object.values(addItem.photos).length < 4) {
                                            alert(t('missing_item_photo_prompt'))
                                            return;
                                        }
                                        delivery.items[addItem.id] = addItem;

                                        this.setState({delivery: delivery, addItem: null, addFile: null, addFiles: null, isAdding: false});
                                    }}>{t('add_item')}</Button>
                                    )}
                                    <Button className='btn-outline' onClick={e=> {
                                        this.setState({addItem: null, addFile: null, addFiles: null});
                                    }}>{t('cancel')}</Button>
                                </div>
                                )}
                            </div>
                            {addPhoto && this.renderReceiptPhoto()}
                            {addItemPhoto && this.renderItemPhoto()}
                        </div>
                    </div>
                </div>
            );
        }
        return (
            <div className='book-add'>
                <div className='container'>
                    <h1 className='book-title'>{t('add_an_item')}</h1>
                    <div className='book-container'>
                        <div className='book_notation' style={{textAlign: 'left'}}>{t('add_item_note')}</div>

                        {viewArr.length > 0 && viewArr}
                        
                        <div className='wrap-content-parent'>
                            <div className='wrap-content-fill-child' />
                            <Button className='btn-outline' onClick={e=> {
                                this.setState({isAdding: false});
                            }}>{t('cancel')}</Button>
                        </div>
                        <div style={{height: 10}} />
                    </div>
                    <div style={{height: 30}} />
                </div>
            </div>
        )
    }

    getStoreLocation() {
        const {delivery, storeInput} = this.state;
        if (storeInput && (!delivery.location.store || delivery.location.store.formatted_address !== storeInput)) {
            const store = {
                formatted_address: storeInput,
                lat: -1,
                lng: -1,
            };
            if (delivery.location.store && delivery.location.store.unitNumber !== undefined) {
                store.unitNumber = delivery.location.store.unitNumber;
            }
            if (delivery.location.store && delivery.location.store.needStairs !== undefined) {
                store.needStairs = delivery.location.store.needStairs;
            }
            if (delivery.location.store && delivery.location.store.hardwood !== undefined) {
                store.hardwood = delivery.location.store.hardwood;
            }
            if (delivery.location.store && delivery.location.store.parkingInfo !== undefined) {
                store.parkingInfo = delivery.location.store.parkingInfo;
            }
            
            return store;
        } else if (delivery.location.store && delivery.location.store.formatted_address) {
            return delivery.location.store;
        }

        return null;
    }

    getDropoffLocation() {
        const {delivery, dropInput} = this.state;
        if (dropInput && (!delivery.location.dropoff || delivery.location.dropoff.formatted_address !== dropInput)) {
            const dropoff = {
                formatted_address: dropInput,
                lat: -1,
                lng: -1,
            };
            if (delivery.location.dropoff && delivery.location.dropoff.unitNumber !== undefined) {
                dropoff.unitNumber = delivery.location.dropoff.unitNumber;
            }
            if (delivery.location.dropoff && delivery.location.dropoff.needStairs !== undefined) {
                dropoff.needStairs = delivery.location.dropoff.needStairs;
            }
            if (delivery.location.dropoff && delivery.location.dropoff.hardwood !== undefined) {
                dropoff.hardwood = delivery.location.dropoff.hardwood;
            }
            if (delivery.location.dropoff && delivery.location.dropoff.parkingInfo !== undefined) {
                dropoff.parkingInfo = delivery.location.dropoff.parkingInfo;
            }
            
            return dropoff;
        } else if (delivery.location.dropoff && delivery.location.dropoff.formatted_address) {
            return delivery.location.dropoff;
        }

        return null;
    }

    renderOrderId() {
        const {delivery} = this.state;
        if (!delivery.customer) {
            delivery.customer = {};
        }

        if (!delivery.location || !this.getStoreLocation() || !this.getDropoffLocation()) {
            return (
                <div>
                    <div className='book-item-subtitle' style={{opacity: 0.5}}>
                        <div className='book-item-index'>4</div>
                        <h3 className='book-item-header'>{t('add_order_id')}</h3>
                    </div>
                </div>
            );
        }
        return (
            <div>
                <div className='book-item-subtitle'>
                    <div className='book-item-index'>4</div>
                    <h3 className='book-item-header'>{t('add_order_id')}</h3>
                </div>
                <div className='input-item'>
                    <h4 className='input-label'>{t('order_id')}</h4>
                    <Input type="text" className='form-control' placeholder={t('order_id_placeholder')} name="firstname" id="firstname" onChange={e => {
                        delivery.orderId = e.target.value;
                        this.setState({delivery: delivery});
                    }} value={delivery.orderId} />
                </div>
                <div className='input-item'>
                    <h4 className='input-label'>{t('hfc_id')}</h4>
                    <Input type="text" className='form-control' placeholder={t('hfc_id_placeholder')} name="firstname" id="firstname" onChange={e => {
                        delivery.hfcId = e.target.value;
                        this.setState({delivery: delivery});
                    }} value={delivery.hfcId} />
                </div>
            </div>
        );
    }

    getMinHour() {
        let now = new Date().valueOf();

        return getHour(now);
    }

    renderDateTime() {
        const {delivery, datePick} = this.state;
        if (!delivery.customer) {
            delivery.customer = {};
        }

        if (!delivery.location || !this.getStoreLocation() || !this.getDropoffLocation()) {
            return (
                <div>
                    <div className='book-item-subtitle' style={{opacity: 0.5}}>
                        <div className='book-item-index'>5</div>
                        <h3 className='book-item-header'>{t('date_time')}</h3>
                    </div>
                </div>
            );
        }

        let now = new Date().valueOf();
        
        let hourStart = 7;
        let hourEnd = 7;

        if (hourStart > 20) {
            hourStart = 20;
        }
        if (hourStart < 7) {
            hourStart = 7;
        }
        if (hourEnd > 20) {
            hourEnd = 20;
        }
        if (hourEnd < 7) {
            hourEnd = 7;
        }
        
        let startVal = hourStart;
        let endVal = hourEnd;
        
        let startMin = 0;
        let endMin = 0;
        
        if (delivery.deadline) {
            startVal = getHour(delivery.deadline);
            startMin = getMinutes(delivery.deadline);
        }
        if (delivery.deadlineTo) {
            endVal = getHour(delivery.deadlineTo);
            endMin = getMinutes(delivery.deadlineTo);
        }
        
        const startShift = startVal >= 12 ? 12 : 0;
        const endShift = endVal >= 12 ? 12 : 0;

        let startArr = [];
        for (let i = 7; i < 20; i ++) {
            startArr.push(i);
        }
        let endArr = [];
        for (let i = 7; i < 20; i ++) {
            endArr.push(i);
        }
        
        const dayStart = delivery.deadline ? getDayStart(delivery.deadline) : datePick;

        return (
            <div>
                <div className='book-item-subtitle'>
                    <div className='book-item-index'>5</div>
                    <h3 className='book-item-header'>{t('date_time')}</h3>
                </div>
                <div className='input-item'>
                    <div className='info-label-l'><b>{t('book_date_title')}</b></div>
                    <div className='info-label-l'>{t('book_date_text')}</div>
                    <div style={{height: 15}} />
                    <h4 className='info-label-l'>{t('book_date_label')}: {dayStart ? toSimpleDate(dayStart) : ""}</h4>
                    <div style={{height: 15}} />
                    <div className='book-date-time'>
                        <div className='book-date-control'>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <MobileDatePicker
                                    orientation="portrait" 
                                    shouldDisableMonth={date => {
                                        return date.valueOf() < getDayStart(now);
                                    }}
                                    shouldDisableDate={date => {
                                        return date.valueOf() < getDayStart(now);
                                    }}
                                    onChange={ date => {
                                        delivery.deadline = date.valueOf() + startVal * HOUR_TIME + startMin * MIN_TIME;
                                        this.setState({delivery: delivery, datePick: date.valueOf()});
                                    }} />
                            </LocalizationProvider>
                        </div>
                    </div>
                    {dayStart && (
                    <h4 className='info-label-t'>
                        {t('book_time_label')}: {delivery.deadline ? (toSimpleTime(delivery.deadline) + " ~ " + toSimpleTime(delivery.deadline + 4 * HOUR_TIME)) : ""}
                    </h4>
                    )}
                    {delivery.deadline && delivery.deadline < now && (
                    <div className='book-time-warning'><MdError/> {t('invalid_deadline_0')}</div>
                    )}
                    <div className='book-date-time'>
                        <div className='book-time-controls'>
                        {dayStart && (
                        <Input type="select" name="backdrop" className='book-time-control' value={startVal} id="backdrop" onChange={e => {
                            let update = parseInt(e.target.value);
                            
                            delivery.deadline = dayStart + update * HOUR_TIME + startMin * MIN_TIME;
                            this.setState({delivery: delivery});
                        }}>
                        {startArr.map((hr) => (
                            <option value={hr}>{(hr > 12 ? hr - 12: hr) < 10 ? "0" : ""}{hr > 12 ? hr - 12: hr}</option>
                        ))}
                        </Input>
                        )}
                        {dayStart && (
                        <Input type="select" name="backdrop" className='book-time-control' value={startMin} id="backdrop" onChange={e => {
                            delivery.deadline = dayStart + startVal * HOUR_TIME + parseInt(e.target.value) * MIN_TIME ;
                            this.setState({delivery: delivery});
                        }}>
                            <option value={0}>00</option>
                            <option value={15}>15</option>
                            <option value={30}>30</option>
                            <option value={45}>45</option>
                        </Input>
                        )}
                        {dayStart && (
                        <Input type="select" name="backdrop" className='book-time-control' value={startShift} id="backdrop" onChange={e => {
                            let update = parseInt(e.target.value);
                            let hrs = startVal;
                            if (update === 12 && startVal <= 12) {
                                hrs = startVal + 12;
                            } else if (update === 0 && startVal > 12) {
                                hrs = startVal - 12;
                            }
                            if (hrs < 7) {
                                hrs = 7;
                            } else if (hrs > 19) {
                                hrs = 19;
                            }
                            delivery.deadline = dayStart + hrs * HOUR_TIME + startMin * MIN_TIME ;
                            this.setState({delivery: delivery});
                        }}>
                            <option value={0}>AM</option>
                            <option value={12}>PM</option>
                        </Input>
                        )}
                        </div>
                    </div>
                    <div style={{height: 15}} />
                    {delivery.deadline && (
                    <h4 className='info-label-t'>
                        {t('book_time_1_label')}: {delivery.deadlineTo ? (toSimpleTime(delivery.deadlineTo) + " ~ " + toSimpleTime(delivery.deadlineTo + 4 * HOUR_TIME)) : ""}
                    </h4>
                    )}
                    {delivery.deadlineTo && delivery.deadlineTo < now && (
                    <div className='book-time-warning'><MdError/> {t('invalid_deadline_0')}</div>
                    )}
                    <div style={{height: 15}} />
                    <div className='book-date-time'>
                        <div className='book-time-controls'>
                        {delivery.deadline && (
                        <Input type="select" name="backdrop" className='book-time-control' value={endVal} id="backdrop" onChange={e => {
                            let update = parseInt(e.target.value);
                            
                            delivery.deadlineTo = getDayStart(delivery.deadline) + update * HOUR_TIME + endMin * MIN_TIME;
                            this.setState({delivery: delivery});
                        }}>
                        {endArr.map((hr) => (
                            <option value={hr}>{(hr > 12 ? hr - 12: hr) < 10 ? "0" : ""}{hr > 12 ? hr - 12: hr}</option>
                        ))}
                        </Input>
                        )}
                        {delivery.deadline && (
                        <Input type="select" name="backdrop" className='book-time-control' value={endMin} id="backdrop" onChange={e => {
                            delivery.deadlineTo = getDayStart(delivery.deadline) + endVal * HOUR_TIME + parseInt(e.target.value) * MIN_TIME ;
                            this.setState({delivery: delivery});
                        }}>
                            <option value={0}>00</option>
                            <option value={15}>15</option>
                            <option value={30}>30</option>
                            <option value={45}>45</option>
                        </Input>
                        )}
                        {delivery.deadline && (
                        <Input type="select" name="backdrop" className='book-time-control' value={endShift} id="backdrop" onChange={e => {
                            let update = parseInt(e.target.value);
                            let hrs = endVal;
                            if (update === 12 && endVal <= 12) {
                                hrs = endVal + 12;
                            } else if (update === 0 && endVal > 12) {
                                hrs = endVal - 12;
                            }
                            if (hrs < 7) {
                                hrs = 7;
                            } else if (hrs > 19) {
                                hrs = 19;
                            }
                            delivery.deadlineTo = getDayStart(delivery.deadline) + hrs * HOUR_TIME + endMin * MIN_TIME ;
                            this.setState({delivery: delivery});
                        }}>
                            <option value={0}>AM</option>
                            <option value={12}>PM</option>
                        </Input>
                        )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderPayment() {
        const {delivery} = this.state;
        if (!delivery.customer) {
            delivery.customer = {};
        }

        const total = this.getTotalDistance();

        if (!delivery.location || !this.getStoreLocation() || !this.getDropoffLocation()) {
            return (
                <div>
                    <div className='book-item-subtitle' style={{opacity: 0.5}}>
                        <div className='book-item-index'>6</div>
                        <h3 className='book-item-header'>{t('payment')}</h3>
                    </div>
                </div>
            );
        }
        let assembly = 0;
        let itemCount = 0;
        for (const item of Object.values(delivery.items)) {
            if (item.assemblyFull) {
                assembly += item.count;
            }
            itemCount += item.count;
        }
        return (
            <div>
                <div className='book-item-subtitle'>
                    <div className='book-item-index'>6</div>
                    <h3 className='book-item-header'>{t('payment')}</h3>
                </div>
                <h3>{t('price')}: $<span style={{color: '#fa616a'}}>{this.getTotalPrice()}</span></h3>
                <div className='info-label-l'>
                    {t('total_distance')}: {total} {total > 1 ? "miles" : "mile"}
                </div>
                <div className='info-label-l'>
                    {t('items')}: {itemCount}
                </div>
                {assembly > 0 && (
                <div className='info-label-l'>
                    {t('full_assembly_label')}: {assembly}
                </div>
                )}
            </div>
        );
    }

    renderNotes() {
        const {delivery} = this.state;
        if (!delivery.customer) {
            delivery.customer = {};
        }

        if (!delivery.location || !this.getStoreLocation() || !this.getDropoffLocation()) {
            return (
                <div>
                    <div className='book-item-subtitle' style={{opacity: 0.5}}>
                        <div className='book-item-index'>6</div>
                        <h3 className='book-item-header'>{t('optional_notes')}</h3>
                    </div>
                </div>
            );
        }
        return (
            <div>
                <div className='book-item-subtitle'>
                    <div className='book-item-index'>6</div>
                    <h3 className='book-item-header'>{t('optional_notes')}</h3>
                </div>
                <div className='input-item'>
                    <Input type="textarea" className='form-control' placeholder={t('optional_notes_prompt')} name="firstname" id="firstname" onChange={e => {
                        delivery.note = e.target.value;
                        this.setState({delivery: delivery});
                    }} value={delivery.note} />
                </div>
            </div>
        );
    }

    renderStoreList() {
        const {delivery, stores, storeList} = this.state;

        if (storeList) {
            let arr = [];
    
            for (const item of Object.values(stores)) {
                arr.push(
                    <Row style={{margin: 0, height: 40}} onClick={e=> {
                        if (!delivery.location) {
                            delivery.location = {};
                        }
                        delivery.location.store = item;
                        this.setState({delivery: delivery, storeList: false});
                    }}>
                        <h4 className='info-label-l'>
                        <span style={{color: '#A6DC34'}}>{item.storeNumber}</span> {item.name}
                        </h4>
                        <div className='divider' />
                    </Row>
                )
            }

            return (
                <Modal isOpen={storeList}>
                    <ModalBody>
                        <h2 className='info-label-l text-center'>{t('pick_store')}</h2>
                        {arr}
                        <Button className='btn-cancel' onClick={e=> {
                            this.setState({storeList: false});
                        }}>{t('close')}</Button>
                    </ModalBody>
                </Modal>
            )
        } else {
            return <div />;
        }
    }

    renderContents() {
        const {progress, delivery} = this.state;
        
        return (
            <div className='book-layout'>
                <div className='container'>
                    <h1 className='book-title' onClick={e=> {
                        this.props.logout();
                    }}>{t('book_delivery_title')}</h1>
                    <div className='book-container'>
                        <div className='book_notation'>{t('requred_fields_notation')}</div>
                        {this.renderCustomerInfo()}
                        {this.renderLocationInfo()}
                        {this.renderItems()}
                        {this.renderOrderId()}
                        {this.renderDateTime()}
                        {/* {this.renderPayment()} */}
                        {this.renderNotes()}

                        <div className='wrap-content-parent'>
                            <div className='wrap-content-fill-child' />
                            {!progress && (
                            <Button className='btn-normal' style={{marginRight: 10}} onClick={e=> {
                                const update = {
                                    id: delivery.id,
                                }
                                
                                this.setState({delivery: update});
                            }}>{t('clear')}</Button>
                            )}
                            {progress ? (<Spinner size="nm" color='primary' />) : (
                            <Button className='btn-normal' onClick={e=> {
                                this.submitDelivery();
                            }}>{t('book_delivery')}</Button>
                            )}
                        </div>
                    </div>
                    <div style={{height: 30}} />
                </div>
            </div>
        )
    }

    submitDelivery() {
        const {delivery} = this.state;
        if (delivery.location) {
            delivery.location.store = this.getStoreLocation();
            delivery.location.dropoff = this.getDropoffLocation();
        }
        
        if (!delivery.customer || !delivery.customer.email || !validateEmail(delivery.customer.email)) {
            alert(t('invalid_customer_email'));
            return;
        }
        
        if (!delivery.deadline) {
            alert(t('np_deadline'));
            return;
        }
        
        if (delivery.deadline && delivery.deadline < new Date().valueOf()) {
            alert(t('invalid_deadline_0'));
            return;
        }
        
        
        if (delivery.deadlineTo && delivery.deadlineTo < new Date().valueOf()) {
            alert(t('invalid_deadline_0'));
            return;
        }
                
        if (!delivery.customer || !delivery.customer.email || !delivery.customer.phone) {
            alert(t('no_customer_data'));
            return;
        }
        
        if (!delivery.location || !delivery.location.store || !delivery.location.dropoff || !delivery.location.dropoff.formatted_address) {
            alert(t('no_location'));
            return;
        }
        
        if (!delivery.items || Object.values(delivery.items).length < 1) {
            alert(t('no_items'));
            return;
        }        
        
        if (!delivery.orderId) {
            alert(t('no_order_id'));
            return;
        }
        
        
        if (!delivery.id) {
            delivery.id = generateId("delivery");
        }
        const price = this.getTotalPrice();
        if (price > 0) {
            delivery.price = price;
        }
        this.setState({progress: true});
        invokeHttpsApi("delivery-submitDelivery", 
        {
            map: delivery,
            redirectTo: window.location.href,
        }, 
        (async (data)=> {
            alert(t('book_success'));
            if (data.session) {
                const stripe = await loadStripe(STRIPE_PUBLISHABLE_KEY);
                stripe.redirectToCheckout({ sessionId: data.session.id });
                this.setState({progress: false});
            } else {
                this.setState({
                    delivery: {
                        id: generateId("delivery")
                    },
                    dropoff: {},
                    storeInput: null,
                    dropInput: null,
                    createItem: {
                        helperCount: 1
                    },
                    progress: false
                });
            }
        }), ((error)=> {
            alert(t('book_failure') + error);
            this.setState({progress: false});
        }))
    }

    render() {
        const {landingData} = this.state;

        return (
            <div>
                <LandingNav landingData={landingData} location="book" />
                {this.renderContents()}
                {this.renderStoreList()}
                {this.renderAddItem()}
            </div>
        );
    }
}

function mapState(state) {
    const { isAdmin, loggingIn, user, redirectTo } = state.authentication;
    return { isAdmin, loggingIn, user, redirectTo };
}

const actionCreators = {
    login: userActions.login,
    logout: userActions.logout,
    setAuthRedirect: userActions.setAuthRedirect,
};

const connectedBookPage = connect(mapState, actionCreators)(BookPage);
export { connectedBookPage as BookPage };
